<div class="container">
  <p-checkbox [inputId]="uniqueId" [binary]="true" [formControl]="control()" />
  <label class="label-right-of-box" [for]="uniqueId">{{label()}}</label>
</div>